<template>
  <div class="address-create">
    <form @submit.stop.prevent="createAddress">
      <b-row>
        <div class="form-group col-12" v-if="!isProfile">
          <label for="reference" v-translate>Reference Name</label>
          <b-form-input id="reference" v-model="theAddress.reference" />
        </div>
        <div class="form-group col-sm-7">
          <label for="from_extra" v-translate>Street and number</label>
          <div class="input-group">
            <address-autocomplete ref="addressAutocomplete" @selected="checkToPlace" :min-character="4" />
          </div>
          <small class="form-text text-muted" v-translate>We use Google to validate all addresses, please keep it in mind when you enter yours.</small>
        </div>
        <div class="form-group col-sm-5">
          <label for="from_extra" v-translate>Floor, door, etc.</label>
          <div class="input-group">
            <b-form-input id="from_extra" v-model="theAddress.address_extra" />
          </div>
        </div>
        <div class="form-group col-sm-12" v-if="!isProfile">
          <label for="from_contact" v-translate>Contact Name</label>
          <div class="input-group">
            <b-form-input id="from_contact" v-model="theAddress.contact" required />
          </div>
        </div>
        <div class="form-group col-sm-6" v-if="!isProfile">
          <label for="from_email" v-translate>Contact E-mail</label>
          <div class="input-group">
            <b-form-input trim id="from_email" v-model="theAddress.email" required />
          </div>
        </div>
        <div class="form-group col-sm-6" v-if="!isProfile">
          <label for="from_phone" v-translate>Contact Phone</label>
          <div class="input-group">
            <cleave :options="{ phone: true, phoneRegionCode: 'ar' }" class="form-control" v-model="theAddress.phone" required></cleave>
          </div>
        </div>
        <div class="col-12 form-actions">
          <b-button :disabled="!theAddress.place_id" type="submit" variant="secondary" size="md" v-translate>Submit address</b-button>
          <b-button type="button" variant="outline-secondary" size="md" @click.prevent="emitCancel" v-translate>Cancel</b-button>
        </div>
      </b-row>
    </form>
    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickPlaceMap" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
    </b-modal>
  </div>
</template>
<script>
import {
  UserService
} from '@/services/api'
import AddressesMixin from '@/mixins/address.mixin'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import Cleave from 'vue-cleave'
import PlacePicker from '@/components/PlacePicker'

export default {
  emits: ['cancel', 'success'],
  name: 'AddressCreate',
  components: {
    AddressAutocomplete,
    Cleave,
    PlacePicker
  },
  data() {
    return {
      theAddress: {
        reference: null,
        contact: null,
        email: null,
        phone: null,
        place_id: null,
        address_extra: null,
        favourite: false
      },
      ignoreArea: false
    }
  },
  props: {
    isProfile: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mixins: [
    AddressesMixin
  ],
  mounted() {
    if (this.isProfile && this.user) {
      this.setProfileData()
      this.ignoreArea = true
    }
  },
  methods: {
    setProfileData() {
      this.theAddress.reference = this.$gettext('Profile')
      this.theAddress.contact = this.user.name
      this.theAddress.email = this.user.email
      this.theAddress.phone = this.user.phone
    },
    createAddress() {
      if (!this.theAddress.reference) {
        this.theAddress.reference = this.theAddress.contact
      }
      UserService.addAddress(this.user.id, this.theAddress)
        .then(response => {
          if (this.isProfile) {
            UserService.update(this.user.id, { profile_address_id: response.body.id })
              .then(response => {
                this.emitSuccess()
              })
          } else {
            this.emitSuccess()
          }
        })
    },
    async checkToPlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.theAddress.place_id = this.theCheckedAddress.id
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setPlacePicked(place) {
      this.theAddress.place_id = place.id
      this.$refs.addressAutocomplete.searchQuery = place.formatted_address
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    emitCancel() {
      this.$emit('cancel')
    },
    emitSuccess() {
      this.$emit('success')
    }
  }
}
</script>
